<nav id="NavBar" class="navbar nav navbar-expand-custom navbar-inverse fixed-top" role="navigation" style="padding-left:0;" *ngIf="!isExternalJobsiteBrowseJobs">
  <div class="container-fluid" style="flex-wrap: nowrap; padding-left:0; padding-right:0;">
    <div class="navbar-header d-flex flex-row-reverse mr-auto fix-spacing">
      <a class="navbar-brand overflow" href="/Careers/Tasks" style="display: inline-flex;color:black; position: initial;">
        <img id="logo" style="display: inline;" [src]="logoUrl" alt="" />
        <span class="navbar-brand-text" style="font-size: 15px;margin-left: 10px;">
          {{portalName}}
        </span>
      </a>
    </div>
    @if (showLanguageButton && showLogout){
      <select class="form-control" [(ngModel)]="selectedLanguage" name="languages" style="max-width: 200px;">
        <option *ngFor="let lang of languageList" [ngValue]="lang">{{lang.Description}}</option>
      </select>
    }
    <div *ngIf="showLogout" class="navbar-header d-flex flex-row-reverse ml-auto" style="padding-bottom: 2px;">
      <ul class="nav navbar-nav navbar-right">
        <li>
          <a style="text-decoration: none;" href="/Account/Logout?onboard=true" *ngIf="showON">
            Logout
            <div style="margin-left:5px;" class="oi oi-account-logout"></div>
          </a>
          <a #logout style="text-decoration: none;" href="/Account/Logout?applicant=true" *ngIf="showAT">
            Logout
            <div style="margin-left:5px;" class="oi oi-account-logout"></div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
